/**
 * Products vs licence plans. ARVETIO Access Audit and ARVETIO Access Governance are two separate
 * products; internally a licence still carries the plan id ("standard" | "governance").
 * Everything a person reads uses the product names below.
 */
import type { Plan } from "./api/client";
import type { ProductKey } from "./ProductName.jsx";

export const PRODUCT_LABEL: Record<Plan, string> = {
  standard: "ARVETIO Access Audit",
  governance: "ARVETIO Access Governance",
};

/** Short form for compact UI (segmented buttons, badges). */
export const PRODUCT_SHORT: Record<Plan, string> = {
  standard: "Access Audit",
  governance: "Access Governance",
};

export const productKeyForPlan = (plan: Plan | undefined): ProductKey =>
  plan === "governance" ? "access-governance" : "access-audit";

/** Full product name, e.g. for e-mail blocks: "ARVETIO Access Audit for Microsoft 365". */
export const productTitle = (plan: Plan | undefined): string =>
  `${PRODUCT_LABEL[plan ?? "standard"]} for Microsoft 365`;
